import { ModuleRegistry } from "seneca-common/features/module/registry";

import { register as registerConcept } from "./concept";
import { register as registerDelve } from "./delve";
import { register as registerEquation } from "./equation";
import { register as registerExactList } from "./exact-list";
import { register as registerFlashcard } from "./flashcard";
import { register as registerFlow } from "./flow";
import { register as registerGrid } from "./grid";
import { register as registerHierarchy } from "./hierarchy";
import { register as registerHyperFlashcard } from "./hyper-flashcard";
import { register as registerImage } from "./image";
import { register as registerImageChange } from "./image-change";
import { register as registerImageDescription } from "./image-description";
import { register as registerImageLabel } from "./image-label";
import { register as registerImageMultiChoice } from "./image-multi-choice";
import { register as registerImageList } from "./imagelist";
import { register as registerList } from "./list";
import { register as registerMindmap } from "./mindmap";
import { register as registerMultipleChoice } from "./multiplechoice";
import { register as registerMultiSelect } from "./multiSelect";
import { register as registerPattern } from "./pattern";
import { register as registerQuestion } from "./question";
import { register as registerSimpleCalculation } from "./simple-calculation";
import { register as registerTextBlock } from "./text-block";
import { register as registerToggles } from "./toggles";
import { register as registerVideo } from "./video";
import { register as registerWordfill } from "./wordfill";
import { register as registerWorkedExample } from "./worked-example";
import { register as registerWrongWord } from "./wrong-word";

export default function registerModules(moduleRegistry: ModuleRegistry) {
  registerConcept(moduleRegistry);
  registerDelve(moduleRegistry);
  registerEquation(moduleRegistry);
  registerExactList(moduleRegistry);
  registerFlashcard(moduleRegistry);
  registerFlow(moduleRegistry);
  registerGrid(moduleRegistry);
  registerHierarchy(moduleRegistry);
  registerHyperFlashcard(moduleRegistry);
  registerImage(moduleRegistry);
  registerImageChange(moduleRegistry);
  registerImageDescription(moduleRegistry);
  registerImageLabel(moduleRegistry);
  registerImageList(moduleRegistry);
  registerList(moduleRegistry);
  registerMindmap(moduleRegistry);
  registerMultipleChoice(moduleRegistry);
  registerPattern(moduleRegistry);
  registerToggles(moduleRegistry);
  registerVideo(moduleRegistry);
  registerWordfill(moduleRegistry);
  registerWorkedExample(moduleRegistry);
  registerWrongWord(moduleRegistry);
  registerTextBlock(moduleRegistry);
  registerQuestion(moduleRegistry);
  registerImageMultiChoice(moduleRegistry);
  registerMultiSelect(moduleRegistry);
  registerSimpleCalculation(moduleRegistry);
}
